import React, { useEffect, useState } from "react";
import Tooltip from "../Tooltip";

const SectionTitle = ({ title, badgeText = "" }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex justify-start items-center gap-4">
      <h1 className="text-sm md:text-md lg:text-lg font-section-title">{title}</h1>
      {badgeText && (
        <Tooltip
          showOnSmallDevices={true}
          text="This feature might encounter some issues as we refine its functionality."
          direction={isMobile ? "bottom" : "right"}
          width="w-48 md:w-64"
        >
          <span className="text-[12px] md:text-[14px] bg-ov-dark-yellow text-white font-semibold px-2 py-1 rounded-md">
            {badgeText}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default SectionTitle;
